/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */

const resets = [
  // minimal top-level reset
  "html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0);}",
  "body{margin:0;}",
  // minimal form pseudo-element reset
  "button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}",
  "input::-webkit-inner-spin-button,input::-webkit-outer-spin-button," +
    "input::-webkit-search-cancel-button,input::-webkit-search-decoration," +
    "input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}",
]

export default resets
